import type { ResponseStatus } from 'services/assist-api/entities/test-instance-response/types';

export type DataRow = {
  assessmentUserId: number;
  assessmentName: string;
  firstName: string;
  lastName: string;
  fullName: string;
  levelId: number;
  referenceLevelId: number;
  rawScore: number;
  scaleScore: number;
  scaleError: number;
  numberOfItems: number;
  omittedCount: number | undefined;
  stanine: number;
  stage: string;
  status: ResponseStatus;
};

export type Summary = {
  studentsCount: number;
  finishedStudentsCount: number;
  meanScaleScore: number;
  standardDeviation: number;
  stanineMean: number;
  stageMean: number;
  nationalMeanScaleScore?: number;
  nationalStandardDeviation?: number;
  nationalMeanStage?: number;
  yearLevel?: number;
  referenceLevel?: number;
};

export enum LadderType {
  Stage = 'stage',
  Stanine = 'stanine'
}
